import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AddManager = _resolveComponent("AddManager")!
  const _component_ManagersList = _resolveComponent("ManagersList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.userState.admin)
      ? (_openBlock(), _createBlock(_component_AddManager, {
          key: 0,
          color: "green",
          class: "px-6 mt-4 w-full inline-flex justify-end"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ManagersList)
  ], 64))
}